import { Component, Input } from '@angular/core';
import { SimpleSolarCalculatorResult } from '../../../models/analysis/simple-solar-calculator-result';
import {
  CalculatorColorConfig,
  defaultCalculatorColorConfig,
} from '../../calculator/calculator-components/simple-calculator/calculator-color-config';

@Component({
  selector: 'psc-simple-solar-calculation-result',
  templateUrl: './simple-solar-calculation-result.component.html'
})
export class SimpleSolarCalculationResultComponent {
    @Input() result: SimpleSolarCalculatorResult;
  @Input() colorConfig: CalculatorColorConfig = defaultCalculatorColorConfig;
}
